import { Icon, Typography } from '@/components/common';
import Icons from '@/const/icons';
import Image from 'next/image';

export const ChatPlaceholder: React.FC = () => {
	return (
		<div className="h-full rounded-3xl bg-[url(/img/dashboard/bg-chat-placeholder.webp)] bg-no-repeat">
			<div className="flex flex-col justify-center items-center h-full space-y-10">
				<div className="text-center">
					<div className="flex items-center gap-2">
						<Typography type="semibold-20">
							Ask <span className="font-bold text-[1.375rem]">Claim</span>{' '}
							<span className="font-bold text-[1.375rem] text-primary">
								Chat
							</span>
						</Typography>
						<Icon src={Icons.wand} className="text-green-60 !w-6 !h-6" />
					</div>
					<Typography type="semibold-20">anything</Typography>
				</div>
				<Image
					src={'/img/dashboard/rafiki.webp'}
					width={200}
					height={160}
					alt=""
					priority
					quality={50}
				/>
			</div>
		</div>
	);
};
